// extracted by mini-css-extract-plugin
export default {"link":"BE-z","disabled":"CE-z"};